// extracted by mini-css-extract-plugin
module.exports = {"features_wrapper":"features_features_wrapper__lRNPo","content":"features_content__SukOp"};